<template lang="html">
  <div >
    <Header class="header">
      <div class="header-left">
        <router-link to="/main"><img src="~pic/logo_01.png" ></router-link>
      </div>
      <div class="header-mid">
        <ul>
          <li :class="{'active': router_name == 'Main'}"> <router-link :to="{ name: 'Main' }">首页</router-link> </li>
          <li :class="{'active': router_name == 'ForumHistory'}"> <router-link :to="{ name: 'ForumHistory' }">论坛</router-link> </li>
          <li :class="{'active': router_name == 'StudyClass'}"> <router-link :to="{ name: 'StudyClass' }">学习班</router-link> </li>
          <li :class="{'active': router_name == 'Team'}"> <router-link :to="{ name: 'Team' }">团队</router-link> </li>
          <li :class="{'active': router_name == 'Activity'}"> <router-link :to="{ name: 'Activity' }">活动</router-link> </li>
          <li :class="{'active': router_name == 'Partner'}"> <router-link :to="{ name: 'Partner' }">合作伙伴</router-link> </li>
        </ul>
      </div>
      <div class="header-right">
        <Button class="login-btn" type="info" @click="showLogin" v-if="!user_key">注册/登录</Button>
        <Dropdown @on-click="handleClickDropdownItem" v-else>
          <img :src="head_img | logo_show" class="head-img"/>
          <p>个人中心</p>
          <DropdownMenu slot="list">
              <DropdownItem name="user">个人中心</DropdownItem>
              <DropdownItem name="soucang">我的收藏</DropdownItem>
              <DropdownItem name="lunwen">上传论文</DropdownItem>
              <DropdownItem name="liebiao">报名列表</DropdownItem>
              <DropdownItem name="fapiao">申请发票</DropdownItem>
              <DropdownItem name="xuefen">申请学分</DropdownItem>
              <DropdownItem name="loginout">退出登录</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </Header>
  </div>
</template>

<script>
import { logout } from '../../service'
export default {
  inject: ['showLogin'],
  data() {
    return {
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    user_key() {
      return this.$store.state.user_key
    },
    router_name() {
      return this.$route.name
    },
    head_img() {
      return (this.user && this.user.head_path != null) ? this.user.head_path : ''
    }
  },
  methods: {
    async closeLogin() {
      let res = await logout({user_key: this.user_key}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$Message.success('退出成功！')
        this.$store.commit('updateUser', '')
        this.$store.commit('updateUserKey', '')
        this.$store.commit('updateUserMobile', '')

        window.localStorage.removeItem('timestamp_left')
        window.localStorage.removeItem('timestamp_right')
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('user_key')
        window.localStorage.removeItem('user_mobile')

        this.$router.replace({name: 'Main'})
      } else {
        this.$Message.error(res.message)
      }
    },
    handleClickDropdownItem(name) {
      if(name == 'user') {
        this.$router.push({name: 'User'})
      } else if (name == 'loginout'){
        this.closeLogin()
      } else {
        let k_v = {
          'soucang': '1',
          'lunwen': '2',
          'liebiao': '3',
          'fapiao': '4',
          'xuefen': '5'
        }
        this.$router.push({name: 'User', query: { index: k_v[name] }})
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.header
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 80px;
  background: #fff;
  box-shadow: 0px 2px 19px 1px rgba(0, 0, 0, 0.1);
  line-height: 1;
  padding: 0 vw(60) 0 vw(60);
  .header-left
    display: flex;
    align-items: center;
    img
      display: block;
    img:nth-child(1)
      width: 539px;
      height: 80px;
  .header-mid
    ul
      height: 100%;
      display: flex;
      align-items: center;
      li
        list-style: none;
        float: left;
        font-size: 16px;
        vertical-align: middle;
        cursor: pointer;
        a
          color: #666666;
        &.active
          a
            font-weight: bold;
            color: #E12222;
      li+li
        margin-left: vw(40);
  .header-right
    display: flex;
    align-items: center;
    .head-img
      width: 40px
      height: 40px
      border-radius: 50%
    .login-btn
      width: 100px;
      height: 36px;
      line-height: 34px;
      text-align: center;
      cursor: pointer;
      border-radius: 18px;
      border: 1px solid #E12222;
      color: #E12222;
      font-size: 14px;
      padding: 0;
      background: transparent;
    span
      cursor: pointer
      &:hover
        color: #E12222
    >>>.ivu-dropdown-rel
      display: flex;
      align-items: center;
      p
        margin-left: 10px;
        font-size: 14px;
</style>
